import { ApiEndpoints } from "./apiEndpoints";
import { fetchData, setHeaderOptions } from "./apiHelpers";
import {
  CreatePatientProvider,
  PatientProviderRow,
  PatientProviderRowWithProvider,
  SetPrimaryPatientProvider,
} from "./patientProvider.type";

export async function getPatientProviders(
  userId?: string
): Promise<PatientProviderRowWithProvider[]> {
  const slug = ApiEndpoints.patientProvider + (userId ? `/user/${userId}` : "");

  const options = await setHeaderOptions({ method: "GET" });

  return fetchData<PatientProviderRowWithProvider[]>(slug, options);
}

export const createPatientProvider = async (
  patientProvider: CreatePatientProvider
): Promise<PatientProviderRow> => {
  const slug = ApiEndpoints.patientProvider + "/";

  const options = await setHeaderOptions({
    method: "POST",
    body: patientProvider,
  });

  return fetchData<PatientProviderRow>(slug, options);
};

export const setPatientProviderPrimary = async (
  patientProviderId: string,
  body: SetPrimaryPatientProvider
): Promise<PatientProviderRow> => {
  const slug = `${ApiEndpoints.patientProvider}/${patientProviderId}/primary`;

  const options = await setHeaderOptions({
    method: "PUT",
    body,
  });

  return fetchData<PatientProviderRow>(slug, options);
};
